import { getLabelDetail, getLabelIdByName,  addLabel, getCollectInfo, getUserFileLabelNew, getFileLabelList, getUserSubscribeLabeList, getUserCollectLabeList  } from '../actions/subscribe'
import axios from 'axios'
//获取标签id
export function getLabelId (label, userId, isForbidAdd) {
  return new Promise((resolve, eject) => {
    getLabelIdByName({
      lable_content: label
    }).then(res => {
      if (res && res.id) {//已存在，直接添加
        let labelId = res.id
        resolve(labelId)
      } else {//不存在，新增并添加
        if (!isForbidAdd) {
          addLabel({
            lable_content: label,
            lable_created_user: userId
          }).then(resp => {
            if (resp.id) {
              resolve(resp.id)
            }
          })
        } else {
          resolve(null)
        }
      }
    })
  })
}

//获取收藏关系表id
export function getCollectId(fileId, userId) {
  return new Promise((resolve, eject) => {
    getCollectInfo({
      base_file__id: fileId,
      user__id: userId
    }).then(res => {
      if (res && res.results && res.results.length > 0) {
        let id = res.results[0].id
        resolve(id)
      }
    })
  })
}

//获取文件-标签关系表id
export function getFileLabelId(fileId, lableId, userId) {
  return new Promise((resolve, eject) => {
    getUserFileLabelNew({
      page: 1,
      pageSize: 999,
      base_file: fileId,
      lable_update_user: userId
    }).then(res => {
      if (res.results && res.results.length > 0) {
        let data = res.results.filter(v => {
          return v.lable == lableId
        })
        console.log(111, res.results,lableId, data)
        if (data.length > 0) {
          resolve(data[0].id)
        } else {
          resolve('')
        }
      }
    })
  })
}

//获取用户打的文件标签
export function getUserFileLabelList(fileId, userId) {
  return new Promise((resolve, eject) => {
    getUserFileLabelNew({
      page: 1,
      pageSize: 999,
      base_file: fileId,
      lable_update_user: userId
    }).then(res => {
      if (res.results && res.results.length > 0) {
        let data = res.results.map(v => {
          return {
            lable_id: v.id,
            lable_content: v.lable_content,
          }
        })
        resolve(data)
      } else {
        resolve([])
      }
    })
  })
}

//获取用户-订阅标签关系表id
export function getUserSubscribeLabelId(userId, lableId) {
  return new Promise((resolve, eject) => {
    getUserSubscribeLabeList({
      user__id: userId,
      lable__id: lableId,
    }).then(res => {
      if (res.results && res.results.length > 0) {
        let id = res.results[0].id
        resolve(id)
      }
    })
  })
}

//获取用户-收藏标签关系表id
export function getUserCollectLabelId(userId, lableId) {
  return new Promise((resolve, eject) => {
    getUserCollectLabeList({
      user__id: userId,
      lable__id: lableId,
    }).then(res => {
      if (res.results && res.results.length > 0) {
        let id = res.results[0].id
        let labelId = res.results[0].lable
        let userId = res.results[0].user
        resolve({
          id,
          labelId, 
          userId
        })
      }
    })
  })
}

export function exportFile(url, fileName) {
  axios({
    method: 'get',
    url: url,
    responseType: 'blob'
  }).then(resp => {
    if (resp.status === 200) {
      if (window.navigator.msSaveOrOpenBlob) {
        let blob = resp.data;
        navigator.msSaveBlob(blob, fileName)
      } else {
        let blob = new Blob([resp.data], {type: 'text'});
        let a = document.createElement('a');
        a.download = fileName;
        let URL = window.URL || window.webkitURL;
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }
  })
}

export const checkOpen = () => {
  const start = performance.now();
  debugger;
  const end = performance.now();
  if (end - start > 50) {
    window.location.href = 'about:blank'
  }

}